import React, { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/core';

export interface Props extends BoxProps {}

export const TitleRow: FC<Props> = ({ children, ...props }) => {
  return (
    <Box
      d="flex"
      flexDir="row"
      justifyContent="space-between"
      backgroundColor="gray.300"
      borderTop="1px solid"
      borderColor="gray.300"
      paddingTop="2"
      paddingBottom="2"
      paddingLeft="4"
      paddingRight="4"
      minH="48px"
      w="100%"
      {...props}
    >
      {children}
    </Box>
  );
};
